import React from "react";
import Navbar from "../../components/navigation/web/Navbar";
import { TabCharts } from "../../components/Charts.jsx/NewCharts/TabCharts";
import { useTranslation } from "react-i18next";

const ChartsAD = () => {
	const { t } = useTranslation();
	return (
		<>
			<Navbar
				view={{
					title: t("new_charts.title"),
					component: <TabCharts />,
				}}
				right={null}
			/>
		</>
	);
};

export { ChartsAD };
